import axios from 'axios';

import BatchRequest from './batch';
import { BreadcrumbAPI } from './breadcrumb';
import { CartAPI } from './cart';
import { CallCenterAPI } from './call-center';
import CTOAPI from './cto';
import CompatData from './compat-data';
import ServicesAPI from './services';
import DealsAPI from './intra-day-deals-api';
import { endsWith } from '../../../polyfill/index';

// ISNODE is boolean false in production frontend, which makes all URLs relative; boolean true during SSR;
// when it's true, all API URLs get prefixed with production domain to make sure HPServices data is retrievable;
// thanks to endsWith(..., "hp.com") checks, URLs stay prefixed even on local environments when ISNODE might be
// accidentally missing and document.location.hostname resolves to "localhost"
const isNode = process.env.ISNODE;
const basename = process.env.BASENAME;
const batchServices = new BatchRequest();

const _EtrAPI = function () {
    let self = this;
    let currHost = isNode ? 'server' : document.location.hostname;
    let config = {
        siteInfo: {
            langId: -1,
            storeId: 10151,
            catalogId: 10051,
        },
    };
    let httpInstance = axios.create({
        baseURL: endsWith(currHost, 'hp.com') ? `${basename}/` : `https://www.hp.com${basename}/`,
    });
    let etrWebAppInstance = axios.create({
        baseURL: endsWith(currHost, 'hp.com')
            ? '/webapp/wcs/stores/servlet/'
            : 'https://www.hp.com/webapp/wcs/stores/servlet/',
    });
    let etrWCSInstance = axios.create({
        baseURL: endsWith(currHost, 'hp.com') ? '/wcs/resources/store/' : 'https://www.hp.com/wcs/resources/store/',
    });

    self.cartWCS = new CartAPI(config, etrWebAppInstance);
    self.cart = new CartAPI(config, httpInstance);
    self.cto = new CTOAPI(config, httpInstance);
    self.compatData = new CompatData(config, etrWCSInstance);
    self.services = new ServicesAPI(config, httpInstance);
    self.callCenter = new CallCenterAPI(config, httpInstance);
    self.breadcrumb = new BreadcrumbAPI(config, httpInstance);
    self.intraDayDeals = new DealsAPI(config, etrWebAppInstance);
    self.httpInstance = httpInstance;

    //update services api to batch requests
    self.services.hpServices = batchServices.batch(self.services, self.services.hpServices);
};

export const EtrAPI = new _EtrAPI();
